// extracted by mini-css-extract-plugin
module.exports = {"bundleList":"bundle-list_bundleList__aSAVS"};